import type { FaireProductEntity } from "../../entity_types/product";

export const p_53cntr6erm: FaireProductEntity = {
  token: "p_53cntr6erm",
  type: "product",
  name: "Cool Like Mom Iced Coffee Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0c87c35193c27b163c45c804dfc3c1b3db4156e5f195f138554e07c0022c82bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5232f1e5fd2e9b2eb4e897d254f1924d275b26fcadcaacec5352347045c2c07f.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:30.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
